import { Link } from "react-router";
import { useClientContext } from "./ClientWorkspace";
import { RunsView } from "../Activity";

/**
 * Needs attention tab: this client's failed runs.
 *
 * Only runs. A stuck event that never reached a pipeline carries no client to
 * attribute it to, so those stay on the global page rather than being guessed
 * onto one client's tab.
 */
export function ClientAttention() {
  const { org, env, pipelines } = useClientContext();
  return (
    <div>
      <p className="page-help">
        Failed runs for this client. Events that never reached a pipeline are listed under{" "}
        <Link to="/attention">Needs attention</Link>.
      </p>
      <RunsView
        organizationId={org.id}
        status="failed"
        restrictToPipelineIds={env ? pipelines.map((p) => p.id) : undefined}
      />
    </div>
  );
}
